import { ApiRequestInfo } from 'communication/ApiCallInfo';

export enum RequestStatus {
    NONE = 'NONE',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

export interface ApiCallState {
    request: ApiRequestInfo;
}

export interface RequestState {
    status: RequestStatus;
    errorDetails?: RequestError;
    requests: ApiRequestInfo[];
}

export interface RequestError {
    message: string;
    statusCode?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
}

export interface RequestProgressState {
    [key: string]: RequestState;
}

export const initialRequestProgressState: RequestState = {
    status: RequestStatus.NONE,
    requests: [],
};

export const initialRequestsProgressState: RequestProgressState = {};
